<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">사용자 접속 정보</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">사용자 접속 정보</h3>
        <article class="selectOpt type03">
          <div class="flex">
            <dl>
              <dt>사용자명</dt>
              <dd>
                <input type="text" title="사용자명 입력" class="small" v-model="userNm" @keyup.enter="searchBtn" />
              </dd>
            </dl>
            <dl>
              <dt>조회기간</dt>
              <dd>
                <date-picker :propsDate="searchDate" class="middle"></date-picker>
              </dd>
            </dl>
          </div>
          <div class="flex">
            <dl>
              <dt>기관</dt>
              <dd>
                <select name="" id="" title="기관 선택" class="small">
                  <option value="">전체</option>
                </select>
              </dd>
            </dl>
            <dl>
              <dt>접근 IP</dt>
              <dd>
                <input type="text" title="접근 IP 입력" class="w445" v-model="accessIp" @keyup.enter="searchBtn" />
                <button type="button" class="btn dkGray" @click="searchBtn">조회</button>
              </dd>
            </dl>
          </div>
        </article>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ listCnt }}</span
              >건
            </div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  사용자 접속 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">번호</th>
                    <th scope="col">로그 ID</th>
                    <th scope="col">로그인 일시</th>
                    <th scope="col">접속방식</th>
                    <th scope="col">사용자명</th>
                    <th scope="col">접속IP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="6">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in calData" :key="index">
                    <td>{{ startOffset + index + 1 }}</td>
                    <td>{{ item.logId }}</td>
                    <td>{{ item.creatDt }}</td>
                    <td v-if="item.loginMthd == 'I'">로그인</td>
                    <td v-if="item.loginMthd == 'O'">로그아웃</td>
                    <td v-if="item.loginMthd == 'P'">페이지</td>
                    <td>{{ item.loginNm }}</td>
                    <td>{{ item.loginIp }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker2.vue';
import moment from 'moment';

export default {
  data() {
    return {
      nodata: false,
      listData: [],
      listCnt: 0,
      curPageNum: 1,
      dataPerPage: 10,
      checkedValues: [],
      allChecked: false,

      userNm: '',
      accessIp: '',
      searchDate: {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
    };
  },

  components: {
    DatePicker,
  },

  mounted() {
    this.searchBtn();
  },

  methods: {
    async searchBtn() {
      let apiParams = new FormData();
      apiParams.append('re', this.userNm);
      apiParams.append('ip', this.accessIp);
      apiParams.append('logStartDt', this.searchDate.startDate + ' 00:00:00');
      apiParams.append('logEndDt', this.searchDate.endDate + ' 23:59:59');

      const res = await axios('post', '/api/admin/loginHistory/list.json', apiParams);
      const data = res.data;
      if (!data.resultList || data.resultList.length <= 0) {
        this.listData = [];
        this.nodata = true;
        this.curPageNum = 1;
        this.listCnt = 0;
        return;
      }
      this.listData = data.resultList;
      this.nodata = false;
      this.curPageNum = 1;
      this.listCnt = this.listData.length;
    },

    changePerPage(dataPerPage) {
      this.dataPerPage = dataPerPage;
      this.curPageNum = 1;
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length) {
        return this.listData.slice(this.startOffset, this.endOffset);
      }
    },
  },
};
</script>
